import { MessagesView } from "../components/messages/MessagesView"

export const Messages = () => {
  return (
    <MessagesView />
  )
}
